import React, { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { clearBioNudge } from "@/lib/bioNudge";

const MAX = 160;

export const BioNudgeCard = ({ onClose }) => {
  const { t, refreshMe } = useApp();
  const [bio, setBio] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    clearBioNudge();
    api.post("/users/me/bio-nudge/seen").catch(() => {});
  }, []);

  const save = async () => {
    const value = bio.trim();
    if (!value) return;
    setBusy(true);
    try {
      await api.patch("/users/me", { bio: value });
      await refreshMe();
      toast.success(t("bio_nudge.saved", "Intro ajoutée à ton profil ✓"));
      onClose();
    } catch (e) {
      toast.error(e?.friendlyMessage || e?.message || "Erreur");
    } finally { setBusy(false); }
  };

  return (
    <div className="yalola-card p-4 relative animate-in fade-in slide-in-from-top-2 duration-500" data-testid="bio-nudge-card">
      <button type="button" onClick={onClose} className="absolute top-3 right-3 p-1 rounded-full hover:opacity-70" aria-label={t("bio_nudge.later", "Plus tard")} data-testid="bio-nudge-close">
        <X size={16} style={{ color: "var(--yalola-text-muted)" }} />
      </button>
      <div className="flex items-start gap-3 pr-6">
        <div className="h-10 w-10 shrink-0 rounded-full grid place-items-center" style={{ background: "var(--yalola-primary-soft)" }}>
          <Sparkles size={18} style={{ color: "var(--yalola-primary)" }} />
        </div>
        <div className="min-w-0">
          <div className="font-bold font-display" data-testid="bio-nudge-title">{t("bio_nudge.title", "Présente-toi en quelques mots")}</div>
          <p className="text-sm mt-0.5" style={{ color: "var(--yalola-text-muted)" }} data-testid="bio-nudge-desc">
            {t("bio_nudge.desc", "Bravo pour ta publication ! Une courte intro aide les autres membres à te connaître. Tu pourras la modifier à tout moment depuis ton profil.")}
          </p>
        </div>
      </div>
      <Textarea
        rows={2}
        maxLength={MAX}
        value={bio}
        onChange={(e) => setBio(e.target.value.slice(0, MAX))}
        placeholder={t("bio_nudge.placeholder", "Ex. : Passionné(e) de louange, membre d'une église à Bruxelles…")}
        className="mt-3"
        data-testid="bio-nudge-input"
      />
      <div className="flex items-center justify-between gap-3 mt-2">
        <span className="text-[11px] tabular-nums" style={{ color: "var(--yalola-text-muted)" }} data-testid="bio-nudge-counter">{bio.length}/{MAX}</span>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" className="rounded-full" onClick={onClose} disabled={busy} data-testid="bio-nudge-later">{t("bio_nudge.later", "Plus tard")}</Button>
          <Button size="sm" className="rounded-full pill-primary" onClick={save} disabled={busy || !bio.trim()} data-testid="bio-nudge-save">{t("bio_nudge.save", "Enregistrer")}</Button>
        </div>
      </div>
    </div>
  );
};

export default BioNudgeCard;
